// Polyfill
import 'babel-polyfill'

// Vue
import Vue from 'vue'
import App from './App.vue'

// Router
import VueRouter from 'vue-router'
import {
  routes,
  guardRoute
} from './routes'

// Store
import store from './store/store'

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'

// Other Libraries
import VueFlatpickr from 'vue-flatpickr'
import 'vue-flatpickr/theme/airbnb.css'

import moment from 'moment'
import jwtDecode from 'jwt-decode'

// Include Bulma and its overrides (it will be generated as a separate file)
require('../static/style.scss')

Vue.config.productionTip = false

// Router
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((route, redirect, next) => {
  // Check if there's a token
  if (store.getters.token) {
    // Automatically log out the user if the token has expired
    // TODO: Token is expired - reset it
    // Resource: https://goo.gl/7AWk8A
    if (jwtDecode(store.getters.token).exp < Date.now() / 1000) {
      alert('Either you tried to access a restricted area or your token has expired! For security reason, please try to log in again.')
      store.dispatch('logout')
      next('/')
    }

    // User isn't allowed to see the page
    if (typeof route.meta.adminOnly !== 'undefined' && route.meta.adminOnly === true && !['SuperAdmin', 'Admin'].includes(JSON.parse(jwtDecode(store.getters.token).roles)[0].Name)) {
      // alert(`You don't have sufficient privileges to see this page.`)
      next('/')
    }
  }

  store.dispatch('toggleDropDownMenu', false)

  // Set default Authorization header
  if (store.getters.token !== null && typeof store.getters.token !== 'undefined') {
    axios.defaults.headers.common['Authorization'] = store.getters.token // set default header
  }

  guardRoute(route, redirect, next)
})

// Axios
store.dispatch('setUserToken') // Make sure we get token from local storage
Vue.use(VueAxios, axios.create({
  // baseURL: process.env.API_URL,
  validateStatus: status => {
    // Unauthorized
    if (status === 401) {
      alert('Token expired!')
      store.dispatch('logout')
      router.go('/')
      return false
    } else if (status === 403) { // Forbidden
      console.error("Seems like you don't have enough permissions to perform a specific action in this page.")
      // TODO: The following two lines results in an infinite loop. Why?
      // store.dispatch('logout')
      // router.go('/')
      return false
    } else {
      return true
    }
  }
}))

// Datepicker
Vue.use(VueFlatpickr)

// Filters (TODO: Place in a separate file)
Vue.filter('prettifyDate', (value) => {
  return moment(value).format('MM/DD/YYYY hh:mm:ssa')
})

// App
window.app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js